<script setup>
import ItemCollection from "@sabmagento/vue-component-library/ItemCollection";
import ItemName from "@sabmagento/vue-component-library/ItemName";
import Price from "@sabmagento/vue-component-library/Price";
import ProductImage from "@sabmagento/vue-component-library/ProductImage";
import RatingStars from "@sabmagento/vue-component-library/RatingStars";
import SalePrice from "@sabmagento/vue-component-library/SalePrice";
import Swatches from "@sabmagento/vue-component-library/Swatches";
import { ref } from 'vue';

const props = defineProps({
  product: {
    type: Object,
    required: true
  }
});

const emit = defineEmits([
  'productClick'
]);

const primaryImage = ref(props.product.data.image_url);
const secondaryImage = ref(props.product.data.alter_image_url);
/**
 * This being an object is temporary.
 * Vue-Search does not have a Product component, it has a Products component.
 * The Products component stores the selected swatches in object that is passed
 * into the Swatches component.
 * Updating Vue-Search to have a Product component is out of scope currently.
 */
const selectedSwatches = ref({});

</script>

<template>
  <a
    :href="product.data.url"
    @click="emit('productClick', product, selectedSwatches)"
  >
    <ProductImage
      :primary-image="primaryImage"
      :secondary-image="secondaryImage"
      :product-id="product.data.id"
      :placeholder-transformation="'c_pad,e_bgremoval,f_auto,h_564,q_auto,w_422/b_rgb:f3f3f3'"
    />
  </a>

  <a
    :href="product.data.url"
    @click="emit('productClick', product, selectedSwatches)"
  >
    <ItemCollection :collection="product.data.brand_collection" />
    <ItemName :name="product.value" />
  </a>

  <RatingStars
    :rating="product.data.average_rating"
    :review-count="product.data.review_count"
    :url="product.data.url + '#tab-label-product.view.reviews'"
    @product-link-click="emit('productClick', product, selectedSwatches)"
  />

  <Price
    :price-range="product.data.price_range"
  />

  <SalePrice
    v-if="product.data.on_sale_badge"
    :special-price="product.data.special_price"
  />

  <Swatches
    :product="product"
    :selected-swatches="selectedSwatches"
    :show-swatch-count="false"
    @swatch-change="(product, swatch) => {
      selectedSwatches[product.data.variation_id] = swatch?.option_id;
      primaryImage = product?.variations_map?.[swatch?.label].image;
      secondaryImage = product?.variations_map?.[swatch?.label].alter_image;
    }"
    @product-link-click="emit('productClick', product, selectedSwatches)"
  />
</template>

<style scoped>
/**
 * This needs to be de-duped at some point.  Copied from Autocomplete.
 * Reverted :deep on parent because :deep impacts RatingStars.
 */
a {
  color: var(--color-dark-gray);
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-normal);
  letter-spacing: 0.2px;
  line-height: 1.3;
  text-align: left;
  text-decoration: none;
}

:deep(.product-image) {
  margin-bottom: 15px;
}
</style>
